module.exports = __webpack_public_path__ + "img/redo.5e79a95d.svg";